import { useState } from 'react';

/** A token from the URL fragment, which never reaches server logs. Removed from the address bar. */
export function useFragmentToken(): string {
  const [token] = useState(() => {
    const value = window.location.hash.slice(1);
    window.history.replaceState(null, '', window.location.pathname);
    return value;
  });
  return token;
}
